import React from 'react';
import DefaultSummary from './DefaultSummary';
const NoteSummary = (props) => React.createElement(DefaultSummary, Object.assign({}, props));
export default NoteSummary;
//# sourceMappingURL=NoteSummary.js.map